package fr.frux.feature.map

import fr.frux.shared.domain.model.Species
import fr.frux.shared.domain.model.Tree
import fr.frux.shared.domain.model.offeredForTrees

/** En deca de cette longueur, la recherche texte ne filtre rien : trop de bruit pour du signal. */
internal const val MIN_SEARCH_QUERY_LENGTH = 2

/** Plancher de la recherche de lieux (#394) : le serveur refuse en dessous, autant ne pas l'appeler. */
internal const val MIN_PLACE_QUERY_LENGTH = 3
private const val MAX_SPECIES_SUGGESTIONS = 5

/** Arbres dont l'espece repond au texte cherche, par nom commun ou scientifique, accents ignores. */
internal fun matchingTrees(
    query: String,
    trees: List<Tree>,
): List<Tree> =
    if (query.length < MIN_SEARCH_QUERY_LENGTH) {
        emptyList()
    } else {
        trees.filter { it.species.matches(query) }
    }

/** Suggestions d'especes selectionnables pour le texte cherche, plafonnees pour rester lisibles. */
internal fun matchingSpecies(
    query: String,
    species: List<Species>,
): List<Species> =
    if (query.length < MIN_SEARCH_QUERY_LENGTH) {
        emptyList()
    } else {
        species.filter { it.offeredForTrees && it.matches(query) }.take(MAX_SPECIES_SUGGESTIONS)
    }

/**
 * Ordre de la liste de resultats (#394) : les lieux en tete, sauf quand la requete nomme une
 * espece (« pommier » est aussi une commune) : l'espece et ses arbres restent alors en premier.
 */
internal fun placesFirst(speciesSuggestions: List<Species>): Boolean = speciesSuggestions.isEmpty()
